import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
  MarkerWrapper,
  Icon,
  TooltipInside,
  TooltipArrow,
} from './styles';

const Marker = ({
  index,
  text,
  activeMarker,
  children,
  markerClick,
  $hover,
}) => (
  <MarkerWrapper>
    <Icon
      alt={text}
      onClick={markerClick}
      $activeMarker={index === activeMarker}
    />
    {children}
    {$hover && (
      <Tooltip className="tooltip">
        <TooltipInside>{text}</TooltipInside>
        <TooltipArrow />
      </Tooltip>
    )}
  </MarkerWrapper>
);

Marker.defaultProps = {
  markerClick: null,
};

Marker.propTypes = {
  index: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  activeMarker: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  markerClick: PropTypes.func,
  $hover: PropTypes.bool,
};

export default Marker;
